export const ICON_PROJECT = 'project';

export const ICON_GROUP = 'group';

export const ICON_SUBGROUP = 'subgroup';

export const LARGE_AVATAR_PX = 32;

export const SMALL_AVATAR_PX = 16;

export const FIRST_DROPDOWN_INDEX = 0;

export const SEARCH_BOX_INDEX = -1;

export const SEARCH_SHORTCUTS_MIN_CHARACTERS = 2;

export const SEARCH_INPUT_DESCRIPTION = 'search-input-description';

export const SEARCH_RESULTS_DESCRIPTION = 'search-results-description';

export const SCOPE_TOKEN_MAX_LENGTH = 36;

export const INPUT_FIELD_PADDING = 52;

export const HEADER_INIT_EVENTS = ['input', 'focus'];

export const IS_SEARCHING = 'is-searching';
export const IS_FOCUSED = 'is-focused';
export const IS_NOT_FOCUSED = 'is-not-focused';

export const FETCH_TYPES = ['generic', 'search'];

export const SEARCH_INPUT_FIELD_MAX_WIDTH = '640px';

export const DROPDOWN_CLOSE_TIMEOUT = 200;
